import React from "react";
import { useDimensions } from "../../../hooks/useDimensions";
import { FormatoCheckPruebas } from "../../customFunctionalComponents/Formatos/FormatoCheckPruebas";
import { FormatoEnRuta } from "../../customFunctionalComponents/Formatos/FormatoEnRuta";
import { FormatoRegreso } from "../../customFunctionalComponents/Formatos/FormatoRegreso";
import { FormatoTodosLosDetalles } from "../../customFunctionalComponents/Formatos/FormatoTodosLosDetalles";

export const SidebarDetails = ({ hideSidebar, unidad, viaje }) => {
  const { width } = useDimensions();
  console.log(viaje.status_id);

  return (
    <div
      className="right"
      style={{
        maxWidth: 500,
        width: width > 385 ? 385 : width - width * 0.1,
        height: "auto",
        backgroundColor: "white",
        borderColor: "white",
        margin: "59px 0 0",
      }}
    >
      {(viaje.status_id === 8 || viaje.status_id === 9) && (
        <FormatoTodosLosDetalles
          hideSidebar={hideSidebar}
          unidad={unidad}
          viaje={viaje}
        ></FormatoTodosLosDetalles>
      )}

      {/* {viaje.status_id === 6 && (
        <FormatoSalida
          hideSidebar={hideSidebar}
          unidad={unidad}
          viaje={viaje}
        ></FormatoSalida>
      )} */}
      {/* {(viaje.status_id === 5) && (
        <FormatoCheckPruebas
          hideSidebar={hideSidebar}
          unidad={unidad}
          viaje={viaje}
        ></FormatoCheckPruebas>
      )} */}
      {viaje.status_id === 6 && (
        <FormatoEnRuta
          hideSidebar={hideSidebar}
          unidad={unidad}
          viaje={viaje}
        ></FormatoEnRuta>
      )}
      {viaje.status_id === 7 && (
        <FormatoRegreso
          hideSidebar={hideSidebar}
          unidad={unidad}
          viaje={viaje}
        ></FormatoRegreso>
      )}
    </div>
  );
};
